document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-amazon-purchase]');
  if (!link) return;
  const asin = link.dataset.asin || '';
  const url = new URL(link.href, window.location.origin);
  if (!/^[A-Z0-9]{10}$/.test(asin) || url.searchParams.get('tag') !== 'silberhazegro-20' || !['amazon.com', 'www.amazon.com'].includes(url.hostname)) {
    event.preventDefault();
    return;
  }
  const detail = {
    product_id: link.dataset.productId,
    variant_id: link.dataset.variantId,
    asin,
    placement: link.closest('.product-card-wrapper') ? 'collection_card' : 'product_page'
  };
  document.dispatchEvent(new CustomEvent('silberhaze:amazon-click', {detail}));
  window.Shopify?.analytics?.publish?.('amazon_affiliate_click', detail);
});
